import { IconProps } from '@diritto/common/style/icon';

const BadgeRatio = 8 / 11;
export const PublishedBadgeIcon = ({ size = 22 }: IconProps) => (
  <svg width={size} height={size * BadgeRatio} viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="22" height="16" rx="2" fill="#6E7781" />
    <path
      d="M3.837 7.30895C5.223 7.12895 6.159 6.87695 6.744 6.49895L10.029 7.30895L10.344 6.39095L7.41 5.69795C7.464 5.56295 7.491 5.41895 7.509 5.25695H9.921V4.32095H7.545V3.69995H6.438V4.32095H4.008V5.25695H6.438C6.267 5.75195 5.448 6.13895 3.576 6.38195L3.837 7.30895ZM10.92 7.53395H3V8.41595H6.384V8.94695H3.882V9.79295H8.85V10.189H3.927V12.322H10.227V11.449H5.07V11.035H10.002V8.94695H7.536V8.41595H10.92V7.53395Z"
      fill="white"
    />
    <path
      d="M17.9062 3.87095H16.7542V10.09H17.9062V6.90395H19.1212V5.85995H17.9062V3.87095ZM15.4402 4.32095H11.3812V5.36495H14.2702C14.1532 6.36395 13.1182 7.38995 11.1382 8.10095L11.6332 9.09995C14.0182 8.22695 15.4402 6.91295 15.4402 4.88795V4.32095ZM12.3712 9.52295V12.277H18.2932V11.233H13.5232V9.52295H12.3712Z"
      fill="white"
    />
  </svg>
);
